import { render, staticRenderFns } from "./cityTotals.vue?vue&type=template&id=494736b1&scoped=true"
import script from "./cityTotals.vue?vue&type=script&lang=js"
export * from "./cityTotals.vue?vue&type=script&lang=js"
import style0 from "./cityTotals.vue?vue&type=style&index=0&id=494736b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494736b1",
  null
  
)

export default component.exports